export const noop = () => void 0;